import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
  checkbox: {},
});

function Checkbox({
  className,
  classes,
  hidden,
  label,
  value,
  helperText,
  ...rest
}) {
  return (
    <MuiFormControlLabel
      label={label}
      className={classNames(classes.root, className)}
      control={
        <MuiCheckbox
          className={classes.checkbox}
          variant="outlined"
          checked={value}
          {...rest}
        />
      }
      hidden={hidden}
    />
  );
}

Checkbox.defaultProps = {
  className: '',
};

Checkbox.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default withStyles(styles, { name: 'Checkbox' })(Checkbox);
